// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f5134664","453":"90ff8c4b"}[chunkId] + ".chunk.js";
};